/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 8: Intermediate: Ordenha (Days 211-240)
 *
 * Ordenha ascending (multilevel wave) introduced.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  aperto: {
    id: 'aperto',
    name: 'Aperto',
    name_pt: 'Aperto',
    sub: 'Press inward from the sides. Not upward.',
    sub_pt: 'Pressione para dentro dos lados. Não para cima.',
    level: 'Intermediate',
    zone: 'Side walls 0-3cm',
    color: '#A07080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

Press the left and right walls of the pelvic floor gently toward each other. This is a horizontal movement, not an upward lift. Like pressing the walls of a narrow corridor from both sides.

Hold for the prescribed time. Release completely. The side walls should widen on the release.

Test: do this with your legs apart. If you feel it in your inner thighs, start again.

Picture it: closing elevator doors gently from left and right. Or pressing two book covers together from the sides. The book (your canal) gets narrower.`,
    inst_pt: `Sente com pés apoiados no chão.

Pressione as paredes esquerda e direita do assoalho suavemente uma em direção à outra. Isso é um movimento horizontal, não uma elevação. Como pressionar as paredes de um corredor estreito dos dois lados.

Segure pelo tempo prescrito. Solte completamente. As paredes laterais devem alargar na soltura.

Teste: faça com pernas abertas. Se sentir nas coxas internas, recomece.

Visualize: fechando portas de elevador suavemente da esquerda e direita. Ou pressionando duas capas de livro juntas dos lados. O livro (seu canal) fica mais estreito.`,
    breathe: 'Exhale to press inward. Inhale to release and widen.',
    breathe_pt: 'Expire para pressionar. Inspire para soltar e alargar.',
    timerCue: `Press in.
Hold.
Widen.`,
    timerCue_pt: `Pressione.
Segure.
Alargue.`,
    feel: 'A medial compression of the lateral walls. Distinct from the upward lift.',
    feel_pt: 'Uma compressão medial das paredes laterais. Distinto da elevação para cima.',
    avoid: 'Do not squeeze your inner thighs together. Do not bear down.',
    avoid_pt: 'Não aperte as coxas internas. Não faça força.',
    type: 'hold',
    sets: 10,
    hold: 10,
    relax: 5,
    rest: 0,
  },

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  ordenha_ascend: {
    id: 'ordenha_ascend',
    name: 'Ordenha Ascending',
    name_pt: 'Ordenha Ascendente',
    sub: 'Level 1. Add Level 2. Add Level 3. Do not skip.',
    sub_pt: 'Nível 1. Adicione Nível 2. Adicione Nível 3. Não pule.',
    level: 'Intermediate',
    zone: 'Full floor 0-10cm',
    color: '#A07080',
    movement: 'squeeze',
    inst: `Sit with feet flat on the floor.

CLOSE and SQUEEZE at Level 1 (the entrance). Hold.

Without releasing Level 1, add Level 2, imagine the contraction moving one floor deeper. Hold both.

Without releasing, add Level 3, the deepest accessible point. Hold all three levels together.

Release completely from base to Level 1. That is one rep.

If Level 3 is not yet clear, stop at Level 2. The depth develops with repetition.

Picture it: an elevator rising one floor at a time. Each level should feel distinct.`,
    inst_pt: `Sente com pés apoiados no chão.

FECHE e APERTE no Nível 1 (a entrada). Segure.

Sem soltar o Nível 1, adicione Nível 2, imagine a contração subindo um andar. Segure ambos.

Sem soltar, adicione Nível 3, o ponto mais profundo acessível. Segure os três níveis.

Solte completamente da base ao Nível 1. Isso é uma repetição.

Se Nível 3 ainda não estiver claro, pare no Nível 2. A profundidade se desenvolve com repetição.

Visualize: elevador subindo um andar de cada vez. Cada nível deve parecer distinto.`,
    breathe: 'Exhale to CLOSE and SQUEEZE at Level 1. Continue exhaling as you layer in Level 2 and Level 3.',
    breathe_pt: 'Expire para FECHAR e APERTAR no Nível 1. Continue expirando conforme adiciona Nível 2 e Nível 3.',
    timerCue: `Level 1.
Add Level 2.
Add Level 3.
Release.`,
    timerCue_pt: `Nível 1.
Adicione Nível 2.
Adicione Nível 3.
Solte.`,
    feel: 'A sequential layering sensation. Like an elevator rising one floor at a time. Each level should feel distinct.',
    feel_pt: 'Uma sensação de camadas sequenciais. Como elevador subindo um andar de cada vez. Cada nível deve parecer distinto.',
    avoid: 'Do not skip levels to reach Level 3. Do not bear down. Do not hold your breath at any level.',
    avoid_pt: 'Não pule níveis para chegar ao Nível 3. Não faça força. Não prenda respiração em nenhum nível.',
    type: 'hold',
    sets: 10,
    hold: 8,
    relax: 8,
    rest: 0,
  },

  pulsacao: {
    id: 'pulsacao',
    name: 'Pulsação',
    name_pt: 'Pulsação',
    sub: '1 second on, 1 second off. Clean rhythm. Each rep starts fresh.',
    sub_pt: '1 segundo liga, 1 segundo desliga. Ritmo limpo. Cada repetição começa limpa.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit with feet flat. CLOSE and SQUEEZE for 1 second. Release completely for 1 second. That is one rep.

Each contraction is independent. Do not let tension accumulate across reps. The release is 50% of the exercise.

After each set, do 3 Gentle Pushes to confirm full rest.

Picture it: a camera shutter. Click open, click closed. Sharp and complete. No blur between open and closed.`,
    inst_pt: `Sente com pés apoiados. FECHE e APERTE por 1 segundo. Solte completamente por 1 segundo. Isso é uma repetição.

Cada contração é independente. Não deixe tensão acumular. A soltura é 50% do exercício.

Após cada série, faça 3 Empurrões Suaves para confirmar repouso.

Visualize: obturador de câmera. Clique abre, clique fecha. Nítido e completo. Sem borrão.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Release.`,
    timerCue_pt: `Aperte.
Solte.`,
    feel: 'Clean on-off rhythm. Release as complete as contraction.',
    feel_pt: 'Ritmo liga-desliga limpo. Soltura tão completa quanto contração.',
    avoid: 'Do not let tension build across reps. Do not bear down.',
    avoid_pt: 'Não deixe tensão acumular entre repetições. Não faça força.',
    type: 'pulse',
    sets: 5,
    rest: 10,
    reps: 12,
    on: 1,
    off: 1,
  },

  squeeze_10s: {
    id: 'squeeze_10s',
    name: 'Peak Hold 10s',
    name_pt: 'Sustentação Pico 10s',
    sub: '70% effort. 10 seconds.',
    sub_pt: '70% de esforço. 10 segundos.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit on chair. CLOSE and SQUEEZE 70%. Hold 10 seconds. Release 10 seconds.

If you cannot hold 10 seconds, hold as long as you can and note the time. Build from there.

Picture it: climbing stairs. Step 1 at 3 seconds. Step 2 at 5. Step 3 at 8. Step 4 at 10. Rest on each landing.`,
    inst_pt: `Sente na cadeira. FECHE e APERTE 70%. Segure 10 segundos. Solte 10 segundos.

Se não conseguir segurar 10 segundos, segure o quanto puder e anote. Construa a partir daí.

Visualize: subindo escadas. Degrau 1 em 3 segundos. Degrau 2 em 5. Degrau 3 em 8. Degrau 4 em 10. Descanse em cada patamar.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 10.
Release.`,
    timerCue_pt: `Aperte.
Segure 10.
Solte.`,
    feel: 'Strong sustained lift. A growing tiredness in the floor as the reps build.',
    feel_pt: 'Elevação sustentada forte. Cansaço crescente no assoalho conforme as repetições avançam.',
    avoid: 'Do not hold breath. Do not bear down.',
    avoid_pt: 'Não prenda respiração. Não faça força.',
    type: 'hold',
    sets: 8,
    hold: 10,
    relax: 10,
    rest: 0,
  },
};

export const days = [
  {
    day: 211, week: 31,
    title: 'Day 211', title_pt: 'Dia 211',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 212, week: 31,
    title: 'Day 212', title_pt: 'Dia 212',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 213, week: 31,
    title: 'Day 213', title_pt: 'Dia 213',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'child_pose_release', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 214, week: 31,
    title: 'Day 214', title_pt: 'Dia 214',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 215, week: 31,
    title: 'Day 215', title_pt: 'Dia 215',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 216, week: 31,
    title: 'Day 216', title_pt: 'Dia 216',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'squeeze_10s', overrides: {"sets": 7} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 217, week: 31,
    title: 'Day 217', title_pt: 'Dia 217',
    exercises: [
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'child_pose_release', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 218, week: 32,
    title: 'Day 218', title_pt: 'Dia 218',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 219, week: 32,
    title: 'Day 219', title_pt: 'Dia 219',
    exercises: [
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 220, week: 32,
    title: 'Day 220', title_pt: 'Dia 220',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'aperto', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 221, week: 32,
    title: 'Day 221', title_pt: 'Dia 221',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 222, week: 32,
    title: 'Day 222', title_pt: 'Dia 222',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 223, week: 32,
    title: 'Day 223', title_pt: 'Dia 223',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 224, week: 32,
    title: 'Day 224', title_pt: 'Dia 224',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 225, week: 33,
    title: 'Day 225', title_pt: 'Dia 225',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
    ], // Total: 305s = 5.1 min
  },
  {
    day: 226, week: 33,
    title: 'Day 226', title_pt: 'Dia 226',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_10s', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 227, week: 33,
    title: 'Day 227', title_pt: 'Dia 227',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'child_pose_release', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 228, week: 33,
    title: 'Day 228', title_pt: 'Dia 228',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 229, week: 33,
    title: 'Day 229', title_pt: 'Dia 229',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 230, week: 33,
    title: 'Day 230', title_pt: 'Dia 230',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 231, week: 33,
    title: 'Day 231', title_pt: 'Dia 231',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 232, week: 34,
    title: 'Day 232', title_pt: 'Dia 232',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 233, week: 34,
    title: 'Day 233', title_pt: 'Dia 233',
    exercises: [
      { ref: 'squeeze_10s', overrides: {} }, // 160s
      { ref: 'ordenha_ascend', overrides: {"sets": 9} }, // 144s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 234, week: 34,
    title: 'Day 234', title_pt: 'Dia 234',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 235, week: 34,
    title: 'Day 235', title_pt: 'Dia 235',
    exercises: [
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'ordenha_ascend', overrides: {"sets": 6} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 301s = 5.0 min
  },
  {
    day: 236, week: 34,
    title: 'Day 236', title_pt: 'Dia 236',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
    ], // Total: 305s = 5.1 min
  },
  {
    day: 237, week: 34,
    title: 'Day 237', title_pt: 'Dia 237',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'child_pose_release', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 238, week: 34,
    title: 'Day 238', title_pt: 'Dia 238',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'aperto', overrides: {"sets": 7} }, // 105s
      { ref: 'child_pose_release', overrides: {"hold": 103} }, // 103s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 239, week: 35,
    title: 'Day 239', title_pt: 'Dia 239',
    exercises: [
      { ref: 'aperto', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 240, week: 35,
    title: 'Day 240', title_pt: 'Dia 240',
    exercises: [
      { ref: 'squeeze_10s', overrides: {"sets": 5} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 300s = 5.0 min
  },
];


export const monthMeta = {
  month: 8,
  program: 'release',
  phase: 'Intermediate: Ordenha',
  phase_pt: 'Intermediario: Ordenha',
  days_range: [211, 240],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}